<template>
    <div class="container activos-page">
        <div class="param-title-wrap">
            <h2 class="param-title"> {{ labels.title }} </h2> 
        </div>
        <div class="activos-table-block mt-4" v-if="activos?.length != 0">
            <CorporateDataTable
                :items="activosTableItems"
                :fields="allFields"
                :filter-defs="tableFilterDefs"
                :search-keys="tableSearchKeys"
                :labels="tableLabels"
                :default-per-page="10"
                :narrow="false"
                @row-clicked="(item) => editActivo(item.id)"
            >
                <template #toolbar-actions>
                    <b-button size="sm" class="table-toolbar-add-btn" @click="createActivo()">
                        {{ labels.addAsset }}
                    </b-button>
                </template>
                <template #cell(tipo_activo_nombre)="data">
                    <div class="text-left">{{ data.item?.tipo_activo_nombre }}</div> 
                </template>
                <template #cell(fecha_compra)="data">
                    <div class="text-center">{{ formatDate(data.item?.fecha_compra) }}</div>
                </template>
            </CorporateDataTable>
        </div>
        <div class="activos-table-block mt-4" v-else>
            <h5>{{ labels.noRow }}</h5> 
        </div>
        <Crear :modalCrear="showModCrear" @creado="actualizarTabla" @cierraModal="closeModal"></Crear>
        <Editar 
            :modalEditar="showModEditar" 
            :infoEditAct="dataActivo" 
            @actualizado="actualizarTabla" 
            @eliminado="actualizarTabla" 
            @cierraModal="closeModal"
        />
    </div>
</template>

<script>
import Activos from '../../services/Activos'
import TipoActivo from '../../services/TipoActivo'
import CorporateDataTable from '../utils/CorporateDataTable.vue'
import Crear from './Crear'
import Editar from './Editar'

export default {
    name:'TipoActivo',
    components:{Crear,Editar,CorporateDataTable},
    data:() => ({
        activos : [],
        showModCrear : false,
        listTipoActivo : [],
        dataActivo : [],
        showModEditar : false
    }),
    computed:{
        labels(){
            if (this.$store.state._language == "es-ES") {
                return {
                    title: "Activos",
                    codigo : "Código",
                    tipo_activo : "Tipo activo",
                    descripcion : "Descripción",
                    fecha_compra : "Fecha compra",
                    noRow : "No hay registros",
                    noMatches: "No se encontraron resultados",
                    searchPlaceholder: "Buscar en la tabla...",
                    rowsPerPage: "Filas por página:",
                    totalRows: "Registros visibles",
                    noSort: "Sin orden",
                    sortAsc: "A-Z / Menor a mayor",
                    sortDesc: "Z-A / Mayor a menor",
                    columns: "Columnas",
                    showAllColumns: "Mostrar todas",
                    filters: "Filtros",
                    clearFilters: "Limpiar filtros",
                    addAsset: "Añadir activo",
                    filterCode: "Filtrar código..."
                }
            }

            return {
                title: "Assets",
                codigo : "Code",
                tipo_activo : "Active type",
                descripcion : "Description",
                fecha_compra : "Purchase date",
                noRow : "There are not records",
                noMatches: "No results found",
                searchPlaceholder: "Search in table...",
                rowsPerPage: "Rows per page:",
                totalRows: "Visible records",
                noSort: "No sorting",
                sortAsc: "A-Z / Low to high",
                sortDesc: "Z-A / High to low",
                columns: "Columns",
                showAllColumns: "Show all",
                filters: "Filters",
                clearFilters: "Clear filters",
                addAsset: "Add asset",
                filterCode: "Filter code..."
            }
        },
        allFields(){
            return [
                { key: 'activo', label: this.labels.codigo, sortable: true, thClass: 'text-center', tdClass: 'text-center' },
                { key: 'tipo_activo_nombre', label: this.labels.tipo_activo, sortable: true, thClass: 'text-center' },
                { key: 'descripcion', label: this.labels.descripcion, sortable: true, thClass: 'text-center' },
                { key: 'fecha_compra', label: this.labels.fecha_compra, sortable: true, thClass: 'text-center', tdClass: 'text-center' }
            ]
        },
        activosTableItems(){
            return (this.activos || []).map((item) => ({
                ...item,
                tipo_activo_nombre: this.nameTipoActivo(item?.tipo_activo)
            }))
        },
        tipoActivoOptions(){
            const base = [{ value: '', text: this.$store.state._language == "es-ES" ? 'Todos los tipos' : 'All types' }]
            const opts = this.listTipoActivo
                .map((tipAct) => ({
                    value: tipAct.tipo_activo,
                    text: tipAct.descripcion
                }))
                .sort((a, b) => a.text.localeCompare(b.text, this.$store.state._language == "es-ES" ? 'es' : 'en'))
            return [...base, ...opts]
        },
        tableFilterDefs(){
            return [
                { key: 'activo', type: 'text', placeholder: this.labels.filterCode },
                { key: 'tipo_activo', type: 'select', options: this.tipoActivoOptions },
                { key: 'fecha_compra_desde', field: 'fecha_compra', type: 'date', mode: 'dateFrom' },
                { key: 'fecha_compra_hasta', field: 'fecha_compra', type: 'date', mode: 'dateTo' }
            ]
        },
        tableSearchKeys(){
            return ['activo', 'tipo_activo_nombre', 'descripcion', 'fecha_compra']
        },
        tableLabels(){
            return {
                noRow: this.labels.noRow,
                noMatches: this.labels.noMatches,
                searchPlaceholder: this.labels.searchPlaceholder,
                rowsPerPage: this.labels.rowsPerPage,
                totalRows: this.labels.totalRows,
                noSort: this.labels.noSort,
                sortAsc: this.labels.sortAsc,
                sortDesc: this.labels.sortDesc,
                columns: this.labels.columns,
                showAllColumns: this.labels.showAllColumns,
                filters: this.labels.filters,
                clearFilters: this.labels.clearFilters
            }
        }
    },
    methods:{
        createActivo(){
            this.showModCrear = true
        },
        editActivo(id){
            Activos.getActivoById(id)
            .then((res) => {
                this.dataActivo = res.data.infoActivo
                this.showModEditar = true
            })
            .catch((error) => { console.log(error) })
        },
        closeModal(val){
            this.showModCrear = val
            this.showModEditar = val
        },
        nameTipoActivo(idTipAct){
            let tipoActivo = this.listTipoActivo.find((tipAct) => tipAct.tipo_activo === idTipAct)
            return tipoActivo?.descripcion || idTipAct
        },
        formatDate(value){
            if (!value) return '--'
            const normalized = value.length === 10 ? `${value}T00:00:00` : value
            const date = new Date(normalized)
            if (Number.isNaN(date.getTime())) return value
            const locale = this.$store.state._language == "es-ES" ? 'es-CO' : 'en-US'
            return new Intl.DateTimeFormat(locale, { year: 'numeric', month: '2-digit', day: '2-digit' }).format(date)
        },
        actualizarTabla(){
            Activos.getAllActivos()
            .then((res) => {
                this.activos = res.data.listActivos
            })
            .catch((err) => { console.log(err)})

            TipoActivo.getAllTipoActivo()
            .then((res) => {
                this.listTipoActivo = res.data.listTipoActivo
            })
            .catch((err) => { console.log(err)})
        }
    },
    mounted(){
        Activos.getAllActivos()
        .then((res) => {
            this.activos = res.data.listActivos
        })
        .catch((err) => { console.log(err)})

        TipoActivo.getAllTipoActivo()
        .then((res) => {
            this.listTipoActivo = res.data.listTipoActivo
        })
        .catch((err) => { console.log(err)})
    }
}
</script>
